import { itemTypes } from '../geoTypeUtils';

const clickOnTile = (resortBadge, geographicalItemType) => {
  if (window.dataLayer && geographicalItemType) {
    switch (geographicalItemType) {
      case itemTypes.resort:
        window.dataLayer.push({
          event: 'resort_click_geotiles',
          eventCategory: 'Resort Info',
          eventAction: 'Click geoTiles',
          eventLabel: resortBadge,
        });
        break;
      case itemTypes.area:
        window.dataLayer.push({
          event: 'area_click_geotiles',
          eventCategory: 'Area Info',
          eventAction: 'Click Geo Tiles',
          eventLabel: resortBadge,
        });
        break;
      case itemTypes.country:
        window.dataLayer.push({
          event: 'country_click_geotiles',
          eventCategory: 'Country Info',
          eventAction: 'Click Geo Tiles',
          eventLabel: resortBadge,
        });
        break;
      default:
    }
  }
};

const visibleTiles = (tiles, geographicalItemType) => {
  if (window.dataLayer && geographicalItemType) {
    switch (geographicalItemType) {
      case itemTypes.resort:
        window.dataLayer.push({
          event: 'resortInfo_badges',
          eventCategory: 'Resort Info',
          eventAction: 'View Badge',
          eventLabel: `${tiles.map((tile) => `${tile.key}`)}`,
        });
        break;
      case itemTypes.area:
        window.dataLayer.push({
          event: 'areaInfo_badges',
          eventCategory: 'Area Info',
          eventAction: 'View Badge',
          eventLabel: `${tiles.map((tile) => `${tile.key}`)}`,
        });
        break;
      default:
    }
  }
};

export { clickOnTile, visibleTiles };
